// Import header_footer js
import Navbar from './pages/header_footer/Navbar';

// Import content pages js
import Home from "./pages/content/Home";
import Login from "./pages/content/Login";
import UserList from "./pages/content/UserList";
import Loadings from "./pages/content/Loading"

// Import functions js
import { appFunc, appConfig } from "./pages/functions/FuncHeader";
import { validateUserLogin } from "./pages/functions/LoginCheck"

// Import routing
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom"

function App() {
    //Initialise
    const [getAppConfig, setAppConfig] = useState(
        {
            [appConfig.isUserLogin]:        false, 
            [appConfig.isUserAdmin]:        false,
            [appConfig.isLoadingScreen]:    false,
        });
    const location = useLocation();
    const navigate = useNavigate();

    // Run once on app load
    useEffect(() => {
        appFunc.setSeverities(appFunc.severitiesLevel.PRINT_LOG);
        showInitialScreen();
    }, [])

    // Validate login on every URL change
    useEffect(() => {
        validateUserLogin(setAppConfig);
    }, [navigate])

	return (
		<div className='mainContainer'>
            {
                getAppConfig[appConfig.isLoadingScreen] ? <Loadings /> : ""
            }
			<Navbar getAppConfig={getAppConfig} setAppConfig={setAppConfig}/>
			<Login getAppConfig={getAppConfig} setAppConfig={setAppConfig}/>
			<div className="container">
				<Routes location={location} key={location.key}>
					<Route path="/" element={<Home getAppConfig={getAppConfig} setAppConfig={setAppConfig}/>} />
					<Route path="/user-list" element={<UserList getAppConfig={getAppConfig} setAppConfig={setAppConfig}/>} />
					<Route path="*" element={<Navigate to="/" replace={true} />} />
				</Routes>
			</div>
		</div>
	);
}

/* Function: showInitialScreen()
   Info: To run on every app load. If API server is not available
        a greyout page is to be displayed.
   Returns: void
*/
function showInitialScreen()
{
    const loadingScreen = document.getElementById("index_loadingScreen");
    const loadingMsg = document.getElementById("index_loadingMsg");

    if (loadingScreen)
    {
        fetch(process.env.REACT_APP_API_STATUS_URL + "/server")
        .then((response) => response.json())
        .then((response) => {
            if (response["Success"] === "PC is online.") 
            {
                loadingScreen.style.marginTop = "-1000vh";
                loadingScreen.style.overflow = "hidden";
                loadingMsg.innerText = "";
            }
            else 
            {
                loadingMsg.innerText = "Server Is Offline ...";    
            }
        })
        .catch((error) => 
        {
            appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, "APP", `[showInitialScreen] ${error}`);
            loadingMsg.innerText = "Server Is Offline ...";
        });
    }
}

export default App;